// extracted by mini-css-extract-plugin
export default {"td":"DistribuidoresIndex_td__PYZMt","inscricao":"DistribuidoresIndex_inscricao__bNuuT"};